import { Divider, Link } from "@mui/material";
import "./MobileSign.scss";
import { palette } from "../../styles/palette";
import { MobileLoginPanel } from "./MobileLoginPanel";
import { MobileAuthenticationPanel } from "./MobileAuthenticationPanel";
import TournamentBar from "../../common/worldcup/TournamentBar";

interface MobileSignInProps {}

export const MobileSignIn: React.FC<MobileSignInProps> = () => {
  return (
    <div className="mobileSignIn__root">
      <TournamentBar />

      <section className="mobileSignIn__form">
        <MobileLoginPanel />
        <Divider
          className="mobileSignIn__divider"
          sx={{
            "&::before, &::after": {
              bgcolor: palette.textSecondary,
            },
          }}
        >
          {" "}
          or{" "}
        </Divider>
        <MobileAuthenticationPanel />
        <Link className="mobileSignIn__createLink" href="/createAccount">
          New here? Create an account
        </Link>
      </section>
    </div>
  );
};
